var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route"},[_vm._v(_vm._s(_vm.routeId))])
}
var staticRenderFns = []

export { render, staticRenderFns }